module.exports = __webpack_public_path__ + "img/a2.46724f20.png";